/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PostXmlToJson
 */
export interface PostXmlToJson {
  /**
   *
   * @type {string}
   * @memberof PostXmlToJson
   */
  value: string;
}

/**
 * Check if a given object implements the PostXmlToJson interface.
 */
export function instanceOfPostXmlToJson(value: object): value is PostXmlToJson {
  if (!("value" in value) || value["value"] === undefined) return false;
  return true;
}

export function PostXmlToJsonFromJSON(json: any): PostXmlToJson {
  return PostXmlToJsonFromJSONTyped(json, false);
}

export function PostXmlToJsonFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PostXmlToJson {
  if (json == null) {
    return json;
  }
  return {
    value: json["value"],
  };
}

export function PostXmlToJsonToJSON(json: any): PostXmlToJson {
  return PostXmlToJsonToJSONTyped(json, false);
}

export function PostXmlToJsonToJSONTyped(
  value?: PostXmlToJson | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    value: value["value"],
  };
}
